import { render, staticRenderFns } from "./FormAction.vue?vue&type=template&id=801d01d8&scoped=true&"
import script from "./FormAction.vue?vue&type=script&lang=js&"
export * from "./FormAction.vue?vue&type=script&lang=js&"
import style0 from "./FormAction.vue?vue&type=style&index=0&id=801d01d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801d01d8",
  null
  
)

export default component.exports